const AppConfig = {
    realm: process.env.REACT_APP_AUTH_REALM,
    client: process.env.REACT_APP_AUTH_CLIENT,
    user_role_code: process.env.REACT_APP_AUTH_SIMPLE_USER_CODE,
}


export default AppConfig